import Sample from "./sample/component";
import group from "./group";
import song_all_about_the_bass from "./_songs/all_about_the_bass.mp3";
import song_dear_future_husband from "./_songs/dear_future_husband.mp3";
import song_dont_be_cruel from "./_songs/dont_be_cruel.mp3";
import song_ham_kummst from "./_songs/ham_kummst.mp3";
import song_just_a_gigollo from "./_songs/just_a_gigollo.mp3";
import song_kuess_mich_halt_mich_lieb_mich from "./_songs/kuess_mich_halt_mich_lieb_mich.mp3";
import song_mambo_italiano from "./_songs/mambo_italiano.mp3";
import song_marvin_gaye from "./_songs/marvin_gaye.mp3";
import song_simply_the_best from "./_songs/simply_the_best.mp3";
import song_stand_by_me from "./_songs/stand_by_me.mp3";
import song_timple_boarischer from "./_songs/timple_boarischer.mp3";
import song_er_gehoert_zu_mir from "./_songs/er_gehoert_zu_mir.mp3"

const Samples = () => {
  const samples = [
    <Sample
      title="Marvin Gaye"
      interpret="Charlie Puth feat. Meghan Trainor"
      description="schöne Nummer zum Tanzen - weltweiter Charthit"
      song={song_marvin_gaye}
    />,
    <Sample
      title="Don't be cruel"
      interpret="Elvis Presley"
      description="...beim Rock 'n' Roll darf Elvis nicht fehlen"
      song={song_dont_be_cruel}
    />,
    <Sample
      title="Dear future husband"
      interpret="Meghan Trainor"
      description="so wünscht sich die Braut ihren Bräutigam in Zukunft"
      song={song_dear_future_husband}
    />,
    <Sample
      title="Er gehört zu mir"
      interpret="Marianne Rosenberg"
      description="Schlager der auf keiner Party fehlen darf"
      song={song_er_gehoert_zu_mir}
    />,
    <Sample
      title="Mambo Italiano"
      interpret="Lido Brothers feat. Maria"
      description="mal ein anderer Rhytmus zum tanzen"
      song={song_mambo_italiano}
    />,
    <Sample
      title="Just a gigollo"
      interpret="David Lee Roth"
      description="... der Zungenbrecher für unseren Schlagzeuger George"
      song={song_just_a_gigollo}
    />,
    <Sample
      title="Simply the best"
      interpret="Tina Turner"
      description="Stimmung und Party... da bleibt keiner sitzen"
      song={song_simply_the_best}
    />,
    <Sample
      title="Stand by me"
      interpret="4 the cause"
      description="zum Tanzen mit Emotion - wünschen sich Braut und Bräutigam"
      song={song_stand_by_me}
    />,
    <Sample
      title="Küss mich, Halt mich, Lieb mich"
      interpret="Ella Endlich"
      description="schöne Nummer als Eröffnungstanz, Brauttanz, Brautschleiertanz"
      song={song_kuess_mich_halt_mich_lieb_mich}
    />,
    <Sample
      title="All about that bass"
      interpret="Meghan Trainor"
      description="Charthit für Party und Tanz"
      song={song_all_about_the_bass}
    />,
    <Sample
      title="Ham kummst"
      interpret="Seiler & Speer"
      description="... hoffentlich sagt das die Braut oder Frau nicht"
      song={song_ham_kummst}
    />,
    <Sample
      title="Timple Boarischer"
      interpret="Zillertaler Schürzenjäger"
      description="für Hochzeit in Tracht, Brautentführung/-verziehen/-stehlen"
      song={song_timple_boarischer}
    />,
  ];
  const groups = group(samples, 3);

  return (
    <div>
      <h2>zu den H&ouml;rproben noch folgendes...</h2>
      <p>
        Unsere H&ouml;rproben sind mit einfachen Mitteln selbst aufgenommen und
        wurden nicht im Tonstudio "manipuliert" - daher ist es bei uns so, dass
        es beim Live-Auftritt noch besser, noch "griffiger" klingt.
      </p>
      <p>
        Es versteht sich von selbst, dass wir unabh&auml;ngig von der
        Aktualit&auml;t der H&ouml;rprobensongs chartm&auml;&szlig;ig immer "up
        to date" sind. Nat&uuml;rlich sind unsere Songproben nur ein kleiner
        Ausschnitt aus dem C'est la vie - Repertoire
      </p>

      {groups.map((group) => (
        <div className="row">{group.map((sample) => <div className="col-sm">{sample}</div>)}</div>
      ))}
    </div>
  );
};

export default Samples;
